// // AttendanceTableCalendar.js
// import React, { useState, useEffect } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { getMonth, getYear } from 'date-fns';
// import './homework.css';

// // Mock Data: Replace with API data as needed
// const attendanceRecords = [
//     { student_id: 1, student_name: 'Satya', date: '2024-09-01', status: 'holiday' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-02', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-03', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-04', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-05', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-06', status: 'holiday' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-07', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-08', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-09', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-10', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-11', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-12', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-13', status: 'holiday' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-14', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-15', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-16', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-17', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-18', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-19', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-20', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-21', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-22', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-23', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-24', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-25', status: 'holiday' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-26', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-27', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-28', status: 'present' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-29', status: 'absent' },
//     { student_id: 1, student_name: 'Satya', date: '2024-09-30', status: 'present' },
//   ];
  

// const AttendanceTableCalendar = () => {
//   const [selectedDate, setSelectedDate] = useState(new Date()); // Default to current date
//   const [filteredData, setFilteredData] = useState([]);

//   // Filter attendance data based on the selected month and year
//   useEffect(() => {
//     const month = getMonth(selectedDate); // Extract month (0-11)
//     const year = getYear(selectedDate);   // Extract year

//     const filtered = attendanceRecords.filter((record) => {
//       const recordDate = new Date(record.date);
//       return (
//         recordDate.getFullYear() === year &&
//         recordDate.getMonth() === month
//       );
//     });

//     setFilteredData(filtered);
//   }, [selectedDate]);

//   return (
//     <div className="calendar-container">
//       <h2>Attendance for Satya</h2>

//       {/* Date Picker for Month and Year */}
//       <div className="date-picker-container">
//         <DatePicker
//           selected={selectedDate}
//           onChange={(date) => setSelectedDate(date)}
//           dateFormat="MMMM yyyy" // Display month and year only
//           showMonthYearPicker // Limit picker to month and year
//           className="custom-date-picker"
//         />
//       </div>

//       {/* Attendance Table */}
//       <table className="attendance-table">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredData.length > 0 ? (
//             filteredData.map((entry) => (
//               <tr key={entry.date} className={`status-${entry.status.toLowerCase()}`}>
//                 <td>{entry.date}</td>
//                 <td>{entry.status}</td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="2">No records found for this month and year</td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AttendanceTableCalendar;

// import React, { useState, useEffect } from 'react';
// import { format, getMonth, getYear, addDays } from 'date-fns';

import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { format, getMonth, getYear } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './homework.css';
import './attendance.css';
import useService from 'views/default/useService';
import { usePostCommonMutation } from 'slices/get/common';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Row, Card } from 'react-bootstrap';
import { PageHeader, LoadingSpinner, NoDataFound } from './CommonComponents';
import './common-components.css';
const moment = require('moment');

const AttendanceDashboard = () => {
  const { checkAccessTime, fetchAccessToken } = useService();
  const [postCommon] = usePostCommonMutation();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [studentName, setStudentName] = useState('Student');

  const month = getMonth(selectedDate);
  const year = getYear(selectedDate);
  let location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    getStudentAttendenceData();
  }, [selectedDate, month, year]);

  const getStudentAttendenceData = async () => {
    setLoading(true);
    const access_token = fetchAccessToken();
    const values = { "date": moment(selectedDate).format('YYYY-MM-DD') };

    await postCommon({ ep: `student/student_attendance`, values, token: access_token })
      .then((response) => {
        if (response && response?.data && response.data.status) {
          const data = response.data.data;

          // Filter attendance records based on the selected month and year
          const filtered = data.filter(record => {
            const recordDate = new Date(record.date);
            return (
              recordDate.getFullYear() === year &&
              recordDate.getMonth() === month
            );
          });

          setFilteredData(filtered);
          if (filtered.length > 0) {
            setStudentName(filtered[0].student_name);
          }
        }
        setLoading(false);
        checkAccessTime(response, currentPath);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // Calculate attendance stats
  const getAttendanceStats = () => {
    const present = filteredData.filter(r => r.status.toLowerCase() === 'present').length;
    const absent = filteredData.filter(r => r.status.toLowerCase() === 'absent').length;
    const holiday = filteredData.filter(r => r.status.toLowerCase() === 'holiday').length;
    const total = filteredData.length;
    const percentage = total > 0 ? Math.round((present / (total - holiday)) * 100) || 0 : 0;
    return { present, absent, holiday, total, percentage };
  };

  const stats = getAttendanceStats();

  // Create a calendar view
  const createCalendar = () => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const calendar = [];

    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDayOfMonth; i++) {
      calendar.push(
        <div key={`empty-${i}`} className="calendar-day-beautiful empty"></div>
      );
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const record = filteredData.find(rec => rec.date === format(date, 'yyyy-MM-dd'));
      const status = record ? record.status.toLowerCase() : 'none';
      const isToday = format(new Date(), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd');

      calendar.push(
        <div key={i} className={`calendar-day-beautiful status-${status} ${isToday ? 'today' : ''}`}>
          <span className="day-number">{i}</span>
          {status !== 'none' && (
            <span className="day-status-icon">
              {status === 'present' && <i className="bi bi-check-circle-fill"></i>}
              {status === 'absent' && <i className="bi bi-x-circle-fill"></i>}
              {status === 'holiday' && <i className="bi bi-sun-fill"></i>}
            </span>
          )}
        </div>
      );
    }

    return calendar;
  };

  // Show loading state
  if (loading) {
    return (
      <div className="attendance-page">
        <LoadingSpinner message="Loading attendance..." fullPage={true} />
      </div>
    );
  }

  return (
    <div className="attendance-page">
      {/* Beautiful Header with Back Button */}
      <PageHeader
        title="Attendance"
        subtitle={`Track your attendance for ${studentName}`}
        icon="calendar-check"
        showBackButton={true}
        gradient="linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
        count={`${stats.percentage}%`}
        countLabel="Attendance"
      />

      {/* Stats Cards */}
      <div className="attendance-stats-grid">
        <div className="stat-card-beautiful present">
          <div className="stat-icon">
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="stat-info">
            <span className="stat-number">{stats.present}</span>
            <span className="stat-label">Present</span>
          </div>
        </div>
        <div className="stat-card-beautiful absent">
          <div className="stat-icon">
            <i className="bi bi-x-circle-fill"></i>
          </div>
          <div className="stat-info">
            <span className="stat-number">{stats.absent}</span>
            <span className="stat-label">Absent</span>
          </div>
        </div>
        <div className="stat-card-beautiful holiday">
          <div className="stat-icon">
            <i className="bi bi-sun-fill"></i>
          </div>
          <div className="stat-info">
            <span className="stat-number">{stats.holiday}</span>
            <span className="stat-label">Holidays</span>
          </div>
        </div>
        <div className="stat-card-beautiful total">
          <div className="stat-icon">
            <i className="bi bi-calendar3"></i>
          </div>
          <div className="stat-info">
            <span className="stat-number">{stats.total}</span>
            <span className="stat-label">Total Days</span>
          </div>
        </div>
      </div>

      {/* Month Picker and Legend */}
      <Card className="attendance-controls-card">
        <Card.Body>
          <Row className="align-items-center">
            <Col xs={12} md={4} className="mb-3 mb-md-0">
              <div className="month-picker-wrapper">
                <i className="bi bi-calendar-month"></i>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="MMMM yyyy"
                  showMonthYearPicker
                  className="month-picker-beautiful"
                  popperPlacement="bottom"
                />
              </div>
            </Col>
            <Col xs={12} md={8}>
              <div className="legend-container">
                <div className="legend-item">
                  <span className="legend-dot present"></span>
                  <span>Present</span>
                </div>
                <div className="legend-item">
                  <span className="legend-dot absent"></span>
                  <span>Absent</span>
                </div>
                <div className="legend-item">
                  <span className="legend-dot holiday"></span>
                  <span>Holiday</span>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Calendar View */}
      <Card className="calendar-card-beautiful">
        <Card.Body>
          <div className="calendar-header-row">
            <span>Sun</span>
            <span>Mon</span>
            <span>Tue</span>
            <span>Wed</span>
            <span>Thu</span>
            <span>Fri</span>
            <span>Sat</span>
          </div>
          <div className="calendar-grid-beautiful">
            {createCalendar()}
          </div>
        </Card.Body>
      </Card>

      {/* Attendance Records Table */}
      {filteredData.length > 0 ? (
        <Card className="records-card-beautiful">
          <Card.Header className="records-header">
            <h5><i className="bi bi-list-ul me-2"></i>Attendance Records</h5>
          </Card.Header>
          <Card.Body className="p-0">
            <div className="records-table-wrapper">
              <table className="records-table-beautiful">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Day</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((entry, index) => {
                    const entryDate = new Date(entry.date);
                    const dayName = format(entryDate, 'EEEE');
                    return (
                      <tr key={entry.date} className={`status-row-${entry.status.toLowerCase()}`} style={{ animationDelay: `${index * 0.05}s` }}>
                        <td>{format(entryDate, 'dd MMM yyyy')}</td>
                        <td>{dayName}</td>
                        <td>
                          <span className={`status-badge-beautiful ${entry.status.toLowerCase()}`}>
                            {entry.status.toLowerCase() === 'present' && <i className="bi bi-check-circle-fill me-1"></i>}
                            {entry.status.toLowerCase() === 'absent' && <i className="bi bi-x-circle-fill me-1"></i>}
                            {entry.status.toLowerCase() === 'holiday' && <i className="bi bi-sun-fill me-1"></i>}
                            {entry.status}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      ) : (
        <NoDataFound
          title="No Attendance Records"
          message="No attendance records found for this month. Please select a different month or check back later."
          icon="calendar-x"
          showBackButton={false}
        />
      )}
    </div>
  );
};

export default AttendanceDashboard;
